import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { getOrderStatusData } from '../../redux/actions/OrderActions'
import md5 from 'md5'
import '../../assets/css/index.css'
import { Redirect } from 'react-router-dom'


const Login = ({
    data,
    getOrderStatusData,
    history,
    ...props
}) => {


    let [errorText, setErrorText] = useState()
    const inputRef = useRef()
    
    const onSubmitForm = (event) => {
        event.preventDefault()
        const orderValue = inputRef.current.value.trim()
        if (orderValue=== "") {
            setErrorText("Boş bırakılamaz")
        } else {
            setErrorText("")
            getOrderStatusData({orderNumber: orderValue, token: md5(orderValue.trim())})
        }

    }

    if (data.result.status === 404) {
        errorText = data.result.message
    }

    if (data.result.status === 200) {
        return (
            <Redirect to={`/siparis-detay?order_number=${data.result.order_number}&order_pass=${data.result.order_pass}`} />
        )
    }

    return (
        <div className="fullPage">
            <div className="fullPage__trackingBoxWrapper">
                <div className="fullPage__trackingBoxWrapper__logo">
                    <img src="//cdn.vivense.com/images/header/logo/Vivense-logotype-white-new.svg" alt="Vivense" />
                </div>
                <div className="fullPage__trackingBoxWrapper__title">
                    SİPARİŞ TAKİP
            </div>
                <div className="fullPage__trackingBoxWrapper__desc">
                    <span className="fullPage__trackingBoxWrapper__desc__regular">Siparişin durumunu öğrenmek için</span> <span className="fullPage__trackingBoxWrapper__desc__bold">sipariş numaranı</span><span className="fullPage__trackingBoxWrapper__desc__regular"> gir.</span>
                </div>
                <div className="fullPage__trackingBoxWrapper__form">
                    <form className="fullPage__trackingBoxWrapper__form__group" onSubmit={onSubmitForm}>
                        <input 
                        type="text" 
                        id="fullPage__trackingBoxWrapper__form__group__input"
                        ref={inputRef}
                         />
                       
                        <button type="submit" className="fullPage__trackingBoxWrapper__form__group__btn"></button>
                        <p className="fullPage__trackingBoxWrapper__form__group__errorText errorText--notFound" >{errorText}</p>
                    </form>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        data: state.orderReducer
    }
}
const mapDisptachToProps = {
    getOrderStatusData
}

export default connect(mapStateToProps, mapDisptachToProps)(Login);
